import { Dictionary } from 'ts-essentials';

import { CreditCardType } from 'apis/billing';
import Amex from 'images/card-icons/amex.svg';
import CreditCard from 'images/card-icons/credit-card.svg';
import DinersClub from 'images/card-icons/diners-club.svg';
import Discover from 'images/card-icons/discover.svg';
import Jcb from 'images/card-icons/jcb.svg';
import MasterCard from 'images/card-icons/master-card.svg';
import Visa from 'images/card-icons/visa.svg';

import { CreditCardAttributes } from './getCreditCardAttributes.types';

/** Represents the anonymized pattern of a generic credit card. */
export const genericCreditCardAnonymizedPattern = '**** **** **** ';

/** Represents the attributes of a generic credit card. */
export const genericCreditCardAttributes: CreditCardAttributes = {
  name: 'Credit Card',
  imageSrc: CreditCard,
  anonymizedPattern: genericCreditCardAnonymizedPattern,
};

/** Represents the attributes of branded credit cards. */
export const brandedCreditCardAttributes: Dictionary<
  CreditCardAttributes,
  CreditCardType
> = {
  ['Visa']: {
    name: 'Visa',
    imageSrc: Visa,
    anonymizedPattern: genericCreditCardAnonymizedPattern,
  },
  ['American Express']: {
    name: 'American Express',
    imageSrc: Amex,
    anonymizedPattern: '**** ****** *',
  },
  ['MasterCard']: {
    name: 'MasterCard',
    imageSrc: MasterCard,
    anonymizedPattern: genericCreditCardAnonymizedPattern,
  },
  ['JCB']: {
    name: 'JCB',
    imageSrc: Jcb,
    anonymizedPattern: genericCreditCardAnonymizedPattern,
  },
  ['Diners Club']: {
    name: 'Diners Club',
    imageSrc: DinersClub,
    anonymizedPattern: '**** **** **',
  },
  ['Discover']: {
    name: 'Discover',
    imageSrc: Discover,
    anonymizedPattern: genericCreditCardAnonymizedPattern,
  },
};

/**
 * Gets the credit card attributes.
 *
 * @param creditCard The credit card brand.
 */
export function getCreditCardAttributes(
  creditCard: CreditCardType | string = '',
): CreditCardAttributes {
  return brandedCreditCardAttributes[creditCard] ?? genericCreditCardAttributes;
}
